import cover1 from '@/assets/images/leaders-group.jpeg'
import cover2 from '@/assets/images/culture-music.jpeg'
import cover3 from '@/assets/images/networking-desk.jpeg'
import cover4 from '@/assets/images/registration-signing.jpeg'
import cover5 from '@/assets/images/culture-chiefs.jpeg'
import cover6 from '@/assets/images/team-registration.jpeg'
import type { ActionVariant, MagazineAction, Issue } from '@/types/magazine'

export const actions: MagazineAction[] = [
  { label: 'Read the Latest Issue', variant: 'primary' },
  { label: 'Explore the Magazine Archive', variant: 'outline' },
  { label: 'Subscribe for Updates', variant: 'ghost' },
]

export const actionClass: Record<ActionVariant, string> = {
  primary:
    'group inline-flex items-center justify-center gap-2 rounded-full bg-ibon-dark px-8 py-4 text-xs font-semibold uppercase tracking-[0.2em] text-white transition-colors hover:bg-ibon-navy',
  outline:
    'group inline-flex items-center justify-center gap-2 rounded-full border border-border px-8 py-4 text-xs font-semibold uppercase tracking-[0.2em] text-ibon-dark transition-colors hover:border-ibon-sky hover:text-ibon-sky',
  ghost:
    'group inline-flex items-center justify-center gap-2 rounded-full px-8 py-4 text-xs font-semibold uppercase tracking-[0.2em] text-text-muted transition-colors hover:text-ibon-dark',
}

export const issues: Issue[] = [
  { title: 'Leaders Shaping Tomorrow', edition: 'Issue 06', date: 'Q2 2025', image: cover1 },
  { title: 'Culture as a Catalyst', edition: 'Issue 05', date: 'Q1 2025', image: cover2 },
  { title: 'The Entrepreneurship Edition', edition: 'Issue 04', date: 'Q4 2024', image: cover3 },
  { title: 'Partnerships for Progress', edition: 'Issue 03', date: 'Q3 2024', image: cover4 },
  { title: 'Voices of Heritage', edition: 'Issue 02', date: 'Q2 2024', image: cover5 },
  { title: 'The Launch Edition', edition: 'Issue 01', date: 'Q1 2024', image: cover6 },
]
